import request from '@/utils/request'
const BASE_URL = '/WhSummaryBook'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/WhSummaryRpt',
      method: 'post',
      data
    })
  },

}